import {Action} from '@ngrx/store';

export const MAIL_TO_SHARED_ACTION = 'MAIL_TO_SHARED_ACTION';

export class MailToSharedActions implements Action {
  readonly type = MAIL_TO_SHARED_ACTION;

  constructor(public payload: any) {
  }
}
